import {
    GETVIEWCONGIGURATIONLISTADMIN_SUCCESS,
    GETVIEWCONGIGURATIONLISTADMIN_FAILED,
    RESET_GETVIEWCONGIGURATIONLISTADMIN,
    LOADING_GETVIEWCONGIGURATIONLISTADMIN,
    NETWORK_GETVIEWCONGIGURATIONLISTADMIN,
} from "../types/index";

import { adminServices } from "../../config/axios";

const resetGetViewConfigurationAdmin = () => {
    return { type: RESET_GETVIEWCONGIGURATIONLISTADMIN };
};


const getViewConfigurationAdminList =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_GETVIEWCONGIGURATIONLISTADMIN });
        await adminServices
            .post("getViewCongigurationListAdmin", userData, {
                headers: { AuthToken: authTokenIs },
            })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch(getViewConfigurationAdminSuccess(res.data));
                        break;
                    default:
                        dispatch(getViewConfigurationAdminFailed(res.data));
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_GETVIEWCONGIGURATIONLISTADMIN,
                    payload: err,
                });
            });

        function getViewConfigurationAdminSuccess(data) {
            return {
                type: GETVIEWCONGIGURATIONLISTADMIN_SUCCESS,
                payload: data,
            };
        }

        function getViewConfigurationAdminFailed(data) {
            return {
                type: GETVIEWCONGIGURATIONLISTADMIN_FAILED,
                payload: data,
            };
        }
    };
export { resetGetViewConfigurationAdmin, getViewConfigurationAdminList };